module.exports = __webpack_public_path__ + "static/media/bsc.1aa88810.svg";